import { doGet } from './Api';

export default class DownloadFormatService {
  static async responseFiles(documentId) {
    const response = await doGet(process.env.REACT_APP_DOWNLOAD_URL_FORMATS + documentId);
    window.open(response.data.data, '_blank');
  }
}
